import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout() {
  return (
    <div className="flex flex-col min-h-screen bg-white font-sans">
      <Header />
      <main className="flex-1 pt-20 md:pt-28 lg:pt-32">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}